import React from 'react'

import {Helmet} from "react-helmet";

// SECTIONS
import SectionHome from './SectionAnotherPage'

import PageAnalytics from '../../components/PageAnalytics'

const Page = (props) => {
  return (
    <div>

      {/* Html header */}
      <Helmet>
        <title>Another Page</title>
      </Helmet>

      {/* Analytics */}
      <PageAnalytics title='Another Page'/>

      <SectionHome />
    </div>
  )
}


export default Page




// WEBPACK FOOTER //
// ./src/pages/AnotherPage/index.js